import { useEffect, useRef, useState } from "react";
import Logo from "./Logo";

export default function Loader({ onDone }) {
  const skip = typeof window !== "undefined" && new URLSearchParams(window.location.search).has("nointro");
  const [phase, setPhase] = useState(skip ? "gone" : "in"); // in -> out -> gone
  const finished = useRef(false);

  useEffect(() => {
    if (skip) { onDone?.(); return; }
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const dur = reduce ? 300 : 2600;

    const finish = () => {
      if (finished.current) return;
      finished.current = true;
      setPhase("out");
      setTimeout(() => { setPhase("gone"); onDone?.(); }, 1000);
    };

    const t1 = setTimeout(finish, dur);
    const opts = { once: true, passive: true };
    ["wheel", "touchstart", "keydown", "pointerdown"].forEach((ev) =>
      window.addEventListener(ev, finish, opts)
    );

    return () => {
      clearTimeout(t1);
      ["wheel", "touchstart", "keydown", "pointerdown"].forEach((ev) =>
        window.removeEventListener(ev, finish)
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (phase === "gone") return null;

  return (
    <div
      data-testid="intro-loader"
      className="fixed inset-0 z-[100] bg-navy flex flex-col items-center justify-center grain"
      style={{
        transform: phase === "out" ? "translateY(-100%)" : "translateY(0)",
        transition: "transform 1s cubic-bezier(0.76,0,0.24,1)",
      }}
    >
      <div style={{ animation: "fadein .8s ease both" }}>
        <Logo size="lg" />
      </div>
      <p className="overline text-gold/80 mt-8" style={{ animation: "fadein .9s ease 1s both" }}>
        Crafted Journeys. Exceptional Experiences.
      </p>
      <div className="h-[1px] w-40 bg-gold/40 mt-10 origin-left" style={{ animation: "growx 2.2s ease .3s both" }} />
      <style>{`
        @keyframes fadein { from { opacity: 0; transform: translateY(8px);} to { opacity: 1; transform: translateY(0);} }
        @keyframes growx { from { transform: scaleX(0);} to { transform: scaleX(1);} }
      `}</style>
    </div>
  );
}
